import { useAct } from 'DashboardUser/store'

export default function StringFilter({filterKey, closeConfiguration}) {
    const act = useAct();

    // const dashboardField = useSel(s => s.dashboard.dashboardFields.find(f => f.id === fieldId) ?? null);
    const filter = useSel(s => s.local.filters ? s.local.filters[filterKey] : null);

    const [containsValue, setContainsValue] = useState(typeof filter === 'string' ? filter : '');

    const containsValueNonSpecial = containsValue && !['[present]', '[blank]'].includes(containsValue) ? containsValue : '';

    const applyContains = (value = null) => {
        const explicitValue = typeof value === 'string' ? value : null;
        const toSet = explicitValue || containsValue || '';
        if (toSet === '') return;
        act.local.setFilter(filterKey, toSet);
        setContainsValue(toSet);
        closeConfiguration();
    }

    const clearFilter = () => {
        act.local.setFilter(filterKey, null);
        setContainsValue('');
        closeConfiguration();
    }

    return <div className="string-filter">
        <div className="filter-configuration-input-container">
            <input type="text" placeholder="Contains..." className="filter-configuration-input" value={containsValueNonSpecial} onChange={e => setContainsValue(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') applyContains(); }} />
        </div>
        <a href="#" className={`filter-configuration-option ${containsValue === '' ? 'disabled' : ''}`}
            onClick={() => applyContains()}>Apply "contains" filter</a>
        <a href="#" className={`filter-configuration-option ${containsValue === '[present]' ? 'active' : ''}`} onClick={() => applyContains('[present]')}>Has value</a>
        <a href="#" className={`filter-configuration-option ${containsValue === '[blank]' ? 'active' : ''}`} onClick={() => applyContains('[blank]')}>Is missing/empty</a>
        {filter && <>
            <div className="filter-configuration-option-divider"></div>
            <a href="#" className="filter-configuration-option configuration-option-clear" onClick={clearFilter}>Clear</a>
        </>}
    </div>

}